export default __webpack_public_path__ + "static/media/pragmatic.108ed532.webp";